import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { MessagesService } from '../../../../services/campaign/messages.service';
import { SmsBubbleComponent } from '../../../messages/sms-bubble/sms-bubble.component';
import { WizardAudienceService } from '../../../../pages/organization/campaigns/create-campaign/wizard-audience.service';
import { SmsParts, formatCount, smsParts } from '../../../../../utils/sms';

/** Step 3: the draft as a handset shows it, with its cost per send. */
@Component({
  selector: 'app-messages-preview',
  standalone: true,
  imports: [FormWrapperComponent, SmsBubbleComponent],
  templateUrl: './messages-preview.component.html',
  styleUrl: '../campaign-preview.css',
})
export class MessagesPreviewComponent {
  @Output() showTestMessage = new EventEmitter();
  messagesService = inject(MessagesService);
  audience = inject(WizardAudienceService);

  readonly formatCount = formatCount;

  get parts(): SmsParts {
    return smsParts(this.messagesService.messages.body);
  }

  /** SMS one send costs: parts × unique recipients, once the audience is known. */
  get units(): number | null {
    if (this.audience.count === null || !this.parts.parts) return null;
    return this.parts.parts * this.audience.count;
  }

  handlePreviewMessage() {
    if (this.messagesService.messages.body) {
      this.showTestMessage.emit(false);
    }
  }
}
